// extracted by mini-css-extract-plugin
export var arrowbtn = "carousel_products-module--arrowbtn--59832";
export var blog_wrap = "carousel_products-module--blog_wrap--4c2f0";
export var carou_bg = "carousel_products-module--carou_bg--c061a";
export var carou_cont = "carousel_products-module--carou_cont--006de";
export var cont = "carousel_products-module--cont--84a02";
export var desk_arrows = "carousel_products-module--desk_arrows--2764b";
export var dsk_arrowbtn = "carousel_products-module--dsk_arrowbtn--aa39a";
export var forw = "carousel_products-module--forw--4414c";
export var groups = "carousel_products-module--groups--dd6dd";
export var head = "carousel_products-module--head--ecd1e";
export var home_wrap = "carousel_products-module--home_wrap--23fce";
export var images = "carousel_products-module--images--b8033";
export var imagespk = "carousel_products-module--imagespk--9eb87";
export var img_2 = "carousel_products-module--img_2--3d141";
export var mob_arrowbtn = "carousel_products-module--mob_arrowbtn--08ca9";
export var notitle = "carousel_products-module--notitle--4adb5";
export var off = "carousel_products-module--off--c434a";
export var qsizes = "carousel_products-module--qsizes--b5429";
export var tees_groups = "carousel_products-module--tees_groups--dacdd";
export var tile = "carousel_products-module--tile--60268";
export var tile_link = "carousel_products-module--tile_link--98ceb";
export var tile_vid = "carousel_products-module--tile_vid--34495";
export var tiles = "carousel_products-module--tiles--423ad";
export var title = "carousel_products-module--title--4601f";
export var title_link = "carousel_products-module--title_link--9046c";
export var wrap = "carousel_products-module--wrap--32b38";